import type {
  TaskCardDemoRow,
  TaskCardDemoSocial
} from '@/app/[locale]/tasks/components/TasksTaskCards/tasksTaskCards.constants'

type Social = NonNullable<TaskCardDemoSocial>

/**
 * A group card keeps the lead platform's link and deadline, and shows the
 * group's brief, every listed platform and their summed reward and slots.
 */
export function applyTaskGroupToRow(
  lead: TaskCardDemoRow,
  brief: TaskCardDemoRow,
  platforms: TaskCardDemoRow[]
): TaskCardDemoRow {
  const socials = [
    ...new Set(platforms.map(p => p.social).filter((s): s is Social => !!s))
  ]
  const sum = (pick: (row: TaskCardDemoRow) => number) =>
    platforms.reduce((total, row) => total + pick(row), 0)
  return {
    ...lead,
    coverUrl: brief.coverUrl ?? lead.coverUrl,
    apiTitle: brief.apiTitle ?? lead.apiTitle,
    apiDescription: brief.apiDescription ?? lead.apiDescription,
    apiBrandName: brief.apiBrandName ?? lead.apiBrandName,
    apiBrandLogoUrl: brief.apiBrandLogoUrl ?? lead.apiBrandLogoUrl,
    apiBrandResources: brief.apiBrandResources ?? lead.apiBrandResources,
    rewardPoints: sum(row => row.rewardPoints),
    participantCurrent: sum(row => row.participantCurrent),
    participantLimit: Math.max(
      1,
      sum(row => row.participantLimit)
    ),
    hoursLeft: Math.min(lead.hoursLeft, ...platforms.map(p => p.hoursLeft)),
    socials: socials.length > 1 ? socials : undefined,
    groupCard: true
  }
}
